/*
 * How many mounted screens hold unsaved work right now. Both unsaved-changes guards count themselves in while dirty,
 * so code outside a form — the expired-session prompt, which would otherwise leave the page for the sign-in form —
 * can ask whether leaving would lose something.
 */
let dirtyScreens = 0;

/** Counts a dirty screen in; call the returned function when it is clean again or unmounts. */
export function holdUnsavedWork(): () => void {
  dirtyScreens += 1;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    dirtyScreens -= 1;
  };
}

/** True while any mounted screen holds unsaved work. */
export function hasUnsavedWork(): boolean {
  return dirtyScreens > 0;
}
